<script setup lang="ts">
import getOfficesResponse from "@/types/responses/getOffices"
import getOfficesType from "@/types/responses/getOffices";
import { Ref, onMounted, ref, computed, watch } from 'vue';
import Api from "@/services/api/ApiServiceFabrick";
import i18n from '@/lang/i18n';

const emit = defineEmits(['update:modelValue']);
const props = withDefaults(
  defineProps<{
    modelValue: officeType | undefined
    selectedOfficeableType: {
      id: number | null,
      name: string | null,
      type: string | null
    }
    errorMessages: string[]
    readonly?: boolean
    clearable?: boolean
    label: string
    }>(),
  {
    readonly: false,
    clearable: true,
    label: i18n.global.t('pages.common.filter.organization'),
  }
)

type officeType = {
  id: number | null,
  type: string,
  name: string | undefined,
  departments: getOfficesType['departments']
}

const items: Ref<officeType[]> = ref([])

onMounted(() => {
  Api().getOffices().then((data: getOfficesResponse[]) => {
    data.forEach((office: getOfficesResponse) => {
      items.value.push({
        id: office.id,
        type: office.type.split('\\')[2],
        name: office.company_name ?? office.operation_office_name,
        departments: office.departments ?? []
      })
    })
  })
})

const modelValue = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emit("update:modelValue", value);
  },
})

const selectableItems = computed(() => {
  if (!props.selectedOfficeableType.type) {
    return items.value
  }
  return items.value.filter((item) => {
    return item.type === props.selectedOfficeableType.type
  })
})

const hasSingleSelectableItem = computed(() => {
  return selectableItems.value.length === 1;
})

watch(selectableItems, (newItems) => {
  if (newItems.length === 1) {
    modelValue.value = newItems[0];
  }
})
</script>
<template>
  <div
    v-if="hasSingleSelectableItem"
    class="pt-2"
  >
    {{ modelValue?.name }}
  </div>
  <v-autocomplete
    v-else
    :label="label"
    v-model="modelValue"
    :items="selectableItems"
    item-title="name"
    item-value="name"
    v-bind="{ 'return-object': true }"
    :readonly="props.readonly"
    :error-messages="props.errorMessages"
    :clearable="props.clearable"
  />
</template>
